export const kendoSelectDict = {
    ru: {
        noSelected: 'Нет выбранных',
        outOf: 'из',
        noElements: 'Нет элементов для отображения',
        all: 'Все',
        selected: 'Выбрано'
    },
    en: {
        noSelected: 'There are no selected items',
        outOf: 'out of',
        noElements: 'There are no elements to display',
        all: 'All',
        selected: 'Selected'
    },
    th: {
        noSelected: 'ไม่มีรายการที่เลือก',
        outOf: 'จาก',
        noElements: 'ไม่มีรายการที่จะแสดง',
        all: 'ทั้งหมด',
        selected: 'เลือกแล้ว'
    },
    tr: {
        noSelected: 'Seçili öğe yok',
        outOf: '/',
        noElements: 'Gösterilecek öğe yok',
        all: 'Tümü',
        selected: 'Seçildi'
    }
};
